import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey } from '../internal.js'

const credentialTypes = [apiKey, 'customer-number'] as const

export type nopkCredType = (typeof credentialTypes)[number]
export const nopkDocumentTypes = [
  'invoice',
  'other',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const nopk: CarrierDef<nopkCredType> = {
  name: 'North Park Transportation',
  scac: 'nopk',
  credentialTypes,
  engineLayers: ['rating', 'pickup', 'tracking', 'documents'],
  documentTypes: nopkDocumentTypes,
  legacyCredMap: [['api-key', 'apiKey']],
  credentialConfig: {
    'customer-number': { customerIdentifier: true },
  },
}
